import * as yup from "yup";

import { yup_password_factory } from "@/utils/yupSchemaUtils";

export const MEMBER_AUTH_VALIDATION = yup.object().shape({
  email: yup.string().email("Enter a valid email address").required("Email is required"),
  password: yup_password_factory(),
});
